const predefinedTrainings = [
    {
        title: "Pecho y Tríceps",
        exercises: [
          { exercise: "1-Press banca", weight: 70, repetitions: 8, sets: 4 },
          { exercise: "1-Aperturas inclinadas", weight: 14, repetitions: 12, sets: 4 },
          { exercise: "1-Press inclinado", weight: 60, repetitions: 8, sets: 4 },
          { exercise: "1-Pull-over", weight: 14, repetitions: 10, sets: 3 },
          { exercise: "1-Press cerrado", weight: 50, repetitions: 12, sets: 4 },
          { exercise: "1-Triceps banco", weight: 0, repetitions: 12, sets: 4 },
        ],
      },
      {
        title: "Espalda y Bíceps",
        exercises: [
          { exercise: "2-Dominadas", weight: 0, repetitions: 5, sets: 4 },
          { exercise: "2-Remo mancuerna", weight: 14, repetitions: 12, sets: 3 },
          { exercise: "2-Remo Barra", weight: 30, repetitions: 12, sets: 4 },
          { exercise: "2-Peso muerto", weight: 65, repetitions: 12, sets: 4 },
          { exercise: "2-Curl Barra", weight: 30, repetitions: 8, sets: 4 },
          { exercise: "2-Curl Biceps", weight: 14, repetitions: 10, sets: 4 },
          { exercise: "2-Martillo", weight: 14, repetitions: 10, sets: 4 },
        ],
      },
      {
        title: "Pierna y Hombro",
        exercises: [
          { exercise: "3-Sentadillas", weight: 60, repetitions: 10, sets: 4 },
          { exercise: "3-Zancadas", weight: 40, repetitions: 8, sets: 4 },
          { exercise: "3-Peso muerto", weight: 65, repetitions: 12, sets: 4 },
          { exercise: "3-Press militar", weight: 50, repetitions: 8, sets: 4 },
          { exercise: "3-Elevaciones laterales", weight: 10, repetitions: 12, sets: 4 },
          { exercise: "3-Elevaciones barra", weight: 20, repetitions: 10, sets: 4 },
        ],
      },
      {
        title: "Fuerza",
        exercises: [
          { exercise: "4-Sentadillas", weight: 70, repetitions: 4, sets: 4 },
          { exercise: "4-Peso muerto", weight: 90, repetitions: 4, sets: 4 },
          { exercise: "4-Press banca", weight: 80, repetitions: 5, sets: 4 },
          { exercise: "4-Press militar", weight: 60, repetitions: 4, sets: 4 },
          { exercise: "4-Dominadas", weight: 0, repetitions: 4, sets: 4 },
          { exercise: "4-Curl barra", weight: 30, repetitions: 8, sets: 3 },
        ],
      },
    ];
  export default predefinedTrainings